import axios from "axios";
import { BACKEND_URL } from "../config_and_helpers/config";
import { showToast } from "../config_and_helpers/helpers";
import { logError } from "../config_and_helpers/logger";

/**
 * Submits a new organoid form.
 *
 * @async
 * @param {Object} formData - Full form data to be submitted
 * @returns {Promise<Object>} success object or error messages
 */
export const submitOrganoidForm = async (formData) => {
  try {
    const response = await axios.post(
      `${BACKEND_URL}receive_organoid_form/`,
      formData,
    );

    return {
      success: true,
      data: response.data,
      toast: () =>
        showToast("Form submitted successfully!", "success", "top-right", 3000),
    };
  } catch (error) {
    logError("experiform_client", "submitOrganoidForm failed", error.response?.data ?? error);
    return Object.values(
      error.response?.data || { error: "Submission failed" },
    );
  }
};
